import React, { useState } from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import usePostHook from "../../customHooks/usePostHook";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { reconcileStockFormValidation } from "../../utils/formValidation";
import Spinner from "../../components/Reuseable/Spinner";
const ReconcileStockComponent = loadable(
  () => import("../../components/PurchaseStock/ReconcileStock")
);
type Props = {};

const ReconcileStock = (props: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      product: "",
      quantity: "",
      description: "",
    },
    resolver: yupResolver(reconcileStockFormValidation),
  });
  const { data: productData, isPending: productLoading } = useGetHook({
    queryKey: [`product`],
    url: `${APIS.PRODUCT}`,
    params: {},
  });
  const [manageStock, setManageStock] = useState<any[]>([]);

  const { isPostLoading, mutateAsync, postData } = usePostHook({
    queryKey: ["reconcile-stock"],
    navigateURL: "/purchase-stock",
  });
  const handleReconcileStock = (value: any) => {
    const product = productData.find((item: any) => item.id === value.product);

    setManageStock((prev) => {
      // Check if product already exists
      const existingProductIndex = prev.findIndex(
        (item) => item.code === product.code
      );

      if (existingProductIndex !== -1) {
        const updatedStock = [...prev];
        updatedStock[existingProductIndex] = {
          id: updatedStock[existingProductIndex].id,
          product: product.id,
          name: product.name,
          code: product.code,
          weight: product.weight,
          quantity: value.quantity,
          description: value.description,
        };
        return updatedStock;
      } else {
        const newValue = {
          id: prev.length + 1,
          product: product.id,
          name: product.name,
          code: product.code,
          weight: product.weight,
          quantity: value.quantity,
          description: value?.description,
        };
        return [...prev, newValue];
      }
    });
    reset();
  };

  const handleManageStock = async () => {
    const url = `${APIS.RECONCILE}`;
    if (manageStock?.length > 0) {
      try {
        const res = await mutateAsync({
          url,
          formData: { products: manageStock },
        });
      } catch (err) {
        toast.error("Error reconciling stock");
      }
    } else {
      toast.error("Add Products to Manage Stock");
    }
  };
  const handleRemoveItem = (id: any) => {
    const manageItem = manageStock?.filter((item) => item.product !== id);
    setManageStock(manageItem);
  };
  return (
    <>
      {productLoading ? (
        <Spinner />
      ) : (
        <ReconcileStockComponent
          productData={productData}
          handleReconcileStock={handleReconcileStock}
          register={register}
          handleSubmit={handleSubmit}
          errors={errors}
          setValue={setValue}
          manageStock={manageStock}
          handleManageStock={handleManageStock}
          handleRemoveItem={handleRemoveItem}
        />
      )}
    </>
  );
};

export default ReconcileStock;
